import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { signal} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RunOutData } from 'src/app/common/models/getRunOutInfo.model';
import { CommonserviceService } from 'src/app/common/services/commonservice.service';
import { UPDATE_RUN_OUT_INFO } from 'src/app/common/graphql/queries';
import { SpinnerService } from 'src/app/common/services/spinner.service';
import { hotCallStatusCode } from 'src/app/common/enums/common.enum';
import { ErrorHandlerService } from 'src/app/common/services/error-handler.service';
import { trimSupplierCode } from 'src/app/common/custom.method';
import { SubmitDialogeComponent } from 'src/app/common/components/submit-dialoge/submit-dialoge.component';

@Component({
  selector: 'app-update-runout-information',
  templateUrl: './update-runout-information.component.html',
  styleUrl: './update-runout-information.component.css'
})
export class UpdateRunoutInformationComponent {
  readonly panelOpenState1 = signal(false);
  readonly panelOpenState2 = signal(false);
  constructor(@Inject(MAT_DIALOG_DATA) public data: {  oldRunOutData: RunOutData, 
    runOutData: RunOutData ,message: string, title: string, showCancelButton: boolean, ticketId: string,
    showSuccess: boolean,showOkButton:boolean,showAlert:boolean},private readonly router: Router, 
    private readonly translate: TranslateService, 
    public dialogRef: MatDialogRef<UpdateRunoutInformationComponent>,
    private readonly commonService: CommonserviceService,
    private readonly spinner: SpinnerService,
    private readonly errorService: ErrorHandlerService,
    private readonly dialog: MatDialog) {
  }

  public ngOnInit(): void {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      this.translate.use(savedLanguage);
    }
  }
  
  public onYes(): void {
    this.dialogRef.close(true);
    this.router.navigate(['/home']);
  }

  public onCancel(): void {
    this.dialogRef.close(false);
  }

  public updateRunOut(): void {
    this.spinner.show();
    const input  = {
      ticketStatus: hotCallStatusCode.Open,
      ticketId: this.data.ticketId,
      knbnNbr: this.data?.runOutData?.kanbanCode,
      partNbr: this.data?.runOutData?.partNumber,
      suplCd: trimSupplierCode(this.data?.runOutData?.supplierCode),
      dockCd: this.data?.runOutData?.dockCode,
      lsAddrTxt: this.data?.runOutData?.linesideAddress,
      intVhcleEmpty: this.data?.runOutData?.vehiclesToEmpty,
      firMsdSeq: this.data?.runOutData?.firstMissedPartSeqNo || 0,
      firVhlSeq: this.data?.runOutData?.firstMissedPartBodyNo || 0,
      pcsRem: this.data?.runOutData?.piecesRemaining,
      seqNbr: parseInt(this.data?.runOutData?.currentVehicleSeq) || 0,
      trkPntName: 0,
    }
    this.commonService.getHcmData(UPDATE_RUN_OUT_INFO, {input}).subscribe({
      next: (response) => {
        if(response?.data?.updateRunOutInfo?.message) {
          this.spinner.hide();
          this.dialogRef.close(true);
          this.onUpdateRunOutSave();
          // this.router.navigate(['/home']);
        } else {
          this.errorService.setErrorMessage([]);
          this.spinner.hide();
          this.dialogRef.close(false);
        }
      },
      error: (error) => {
        this.errorService.setErrorMessage([]);
        this.spinner.hide();
        this.dialogRef.close(false);
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }

    public onUpdateRunOutSave(): void {
      this.translate.get(['updaterunout.title', 'updaterunout.message']).subscribe(translations => {
        const dialogRef = this.dialog.open(SubmitDialogeComponent, {
          width: '568px',
          panelClass: 'centered-dialog',
          data: {
            message: translations['updaterunout.message'],
            title: translations['updaterunout.title'],
            action: "Update Runout",
            showOkButton: true,
            showSuccess: true,
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result === true) {
            this.router.navigate(['/home']);
          }
        });
      });
    }
}
